<div class="form-subcontainer">
    <div class="form-content">
        <!-- <div class="form-header">
            <button clickable="" class="btn-close"><svg xmlns="http://www.w3.org/2000/svg" width="17.657"
                    height="17.657" viewBox="0 0 17.657 17.657">
                    <g _ngcontent-kcr-c822="" id="Group_12987" data-name="Group 12987"
                        transform="translate(-5669.475 -484.975)">
                        <line _ngcontent-kcr-c822="" id="Line_325" data-name="Line 325" x2="12" y2="12"
                            transform="translate(5672.304 487.804)" fill="none" stroke="#bebfbe" stroke-linecap="round"
                            stroke-width="4"></line>
                        <line _ngcontent-kcr-c822="" id="Line_326" data-name="Line 326" x1="12" y2="12"
                            transform="translate(5672.304 487.804)" fill="none" stroke="#bebfbe" stroke-linecap="round"
                            stroke-width="4"></line>
                    </g>
                </svg></button>
            <h2 class="form-title">FAQ</h2>
        </div> -->
        <div>
            <form class="fpx-form-group">
                <section class="faq-container">
                    <p class="heading"><b>{{'FAQ.heading' | translate}}</b></p>
                    <details>
                        <summary><span class="summary-title">{{'FAQ.fq' | translate}}</span>
                            <div class="summary-chevron-up">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-chevron-down">
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                            </div>
                        </summary>
                        <div class="active">

                            <p [innerHTML]="'FAQ.fa' | translate | safeHtml"></p>

                        </div>

                        <div class="summary-chevron-down">
                            <svg xmlns="http://www. w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-up">
                                <polyline points="18 15 12 9 6 15"></polyline>
                            </svg>
                        </div>
                    </details>



                    <details>
                        <summary><span class="summary-title">{{'FAQ.fq1' | translate}}</span>
                            <div class="summary-chevron-up">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-chevron-down">
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                            </div>
                        </summary>
                        <div class="active">

                            <p innerHTML="{{'FAQ.fa1' | translate}}"></p>

                        </div>

                        <div class="summary-chevron-down">
                            <svg xmlns="http://www. w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-up">
                                <polyline points="18 15 12 9 6 15"></polyline>
                            </svg>
                        </div>
                    </details>

                    <details>
                        <summary><span class="summary-title">{{'FAQ.fq2' | translate}}</span>
                            <div class="summary-chevron-up">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-chevron-down">
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                            </div>
                        </summary>
                        <div class="active">

                            <p innerHTML="{{'FAQ.fa2' | translate}}"></p>

                        </div>

                        <div class="summary-chevron-down">
                            <svg xmlns="http://www. w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-up">
                                <polyline points="18 15 12 9 6 15"></polyline>
                            </svg>
                        </div>
                    </details>


                    <details>
                        <summary><span class="summary-title">{{'FAQ.fq3' | translate}}</span>
                            <div class="summary-chevron-up">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-chevron-down">
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                            </div>
                        </summary>
                        <div class="active">

                            <p innerHTML="{{'FAQ.fa3' | translate}}"></p>

                        </div>

                        <div class="summary-chevron-down">
                            <svg xmlns="http://www. w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-up">
                                <polyline points="18 15 12 9 6 15"></polyline>
                            </svg>
                        </div>
                    </details>


                    <details>
                        <summary><span class="summary-title">{{'FAQ.fq4' | translate}}</span>
                            <div class="summary-chevron-up">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-chevron-down">
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                            </div>
                        </summary>
                        <div class="active">
                           <p innerHTML="{{'FAQ.fa4' | translate}}"></p>
                        </div>
                        <div class="summary-chevron-down">
                            <svg xmlns="http://www. w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-up">
                                <polyline points="18 15 12 9 6 15"></polyline>
                            </svg>
                        </div>
                    </details>

                  <details>
                        <summary><span class="summary-title">{{'FAQ.fq5' | translate}}</span>
                            <div class="summary-chevron-up">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-chevron-down">
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                            </div>
                        </summary>
                        <div class="active">
                           <p innerHTML="{{'FAQ.fa5' | translate}}"></p>
                        </div>
                        <div class="summary-chevron-down">
                            <svg xmlns="http://www. w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-up">
                                <polyline points="18 15 12 9 6 15"></polyline>
                            </svg>
                        </div>
                    </details>
                </section>
            </form>
        </div>
    </div>
</div>